<template>
 <ion-page>
		<spot-header :title="pageTitle" :canGoHome="true && !isPrinting" :canGoBack="false && !isPrinting" @pressedGoHome="$router.push('/home')" @pressedGoBack="$router.push('/home')"></spot-header>

		<ion-content :fullscreen="true"> <!--v-if="isActive"-->
			<ion-progress-bar type="indeterminate" v-if="!isActive"></ion-progress-bar>
			<div id="actionArea" v-else>
				<web-socket-reader crReplacedChar="|" @readedBarcode="onReadedBarcode" @readedTag="onReadedTag" @readerError="onReaderError"></web-socket-reader>
				<ion-label color="tertiary" v-if="isPrinting">{{isPrintingText}}</ion-label>
				<div	v-if="enableSearchFields">
					<spot-select
						v-if="searchField.inputType == 'select'"
						:ref="searchField.name"
						:label="searchField.text"
						:allignLabel="searchField.allignLabel"
						:required="searchField.required"
						:placeholder="searchField.placeholder"
						:enabled="searchField.enabled"
						:validationState="searchField.validationState"
						:furtherInfo="searchField.furtherInfo"
						:value="searchField.value"
						:options="tablesData.items"
						:optionField="searchField.refField"
						:canAddItem="searchField.canAddItem"
						:canRefreshList="searchField.canRefresh"
						:canUnlock="searchField.canUnlock"
						:selectedLabel="selectedText"
						:deselectLabel="deselectText"
						:selectLabel="selectText"
						@selected="selectedSearchItem($event)"
						@unselected="setDefault">
					</spot-select>
				</div>
				<div v-for="field in fields" :key="field.id">
					<spot-input
						v-if="(field.inputType == 'text' || field.inputType == 'number')"
						:ref="field.name"
						:label="field.text"
						:allignLabel="field.allignLabel"
						:required="field.required"
						:placeholder="getPlaceHolder(field)"
						:enabled="field.enabled"
						:validationState="field.validationState"
						:furtherInfo="field.furtherInfo"
						:value="field.value"
						:type="field.inputType"
						@textChanged="changedTextField(field.id, $event)">
					</spot-input>
					<ion-textarea
						v-if="field.inputType == 'area'"
						:ref="field.name"
						:placeholder="getPlaceHolder(field)"
						:required="field.required"
						:disabled="!field.enabled"
						:auto-grow="true"
						:value="field.value">
					</ion-textarea>
					<spot-checkbox
						v-if="field.inputType == 'check'"
						:ref="field.name"
						:label="field.text"
						:allignLabel="field.allignLabel"
						:required="field.required"
						:enabled="field.enabled"
						:validationState="field.validationState"
						:value="field.value"
						@checkboxChanged="changedCheckboxField(field.id, $event)"> <!-- @focus="$event.target.select()" -->
					</spot-checkbox>
					<spot-select
						v-if="field.inputType == 'select'"
						:ref="field.name"
						:label="field.text"
						:allignLabel="field.allignLabel"
						:required="field.required"
						:placeholder="getPlaceHolder(field)"
						:enabled="field.enabled"
						:enabledExtraButtons="field.enabledExtraButtons"
						:validationState="field.validationState"
						:furtherInfo="field.furtherInfo"
						:value="field.value"
						:options="getOptions(field.id)"
						:optionField="field.refField"
						:canAddItem="field.canAddItem"
						:canRefreshList="field.canRefresh"
						:canUnlock="field.canUnlock"
						:selectedLabel="selectedText"
						:deselectLabel="deselectText"
						:selectLabel="selectText"
						@selected="assignedSelectField(field.id, $event)"
						@unselected="resetSelectField(field.id)">
					</spot-select>
					<spot-button
						v-if="field.inputType == 'button'"
						:ref="field.name"
						:text="field.text"
						:enabled="!isEmptyRequiredFields && !isPrinting && canPrint"
						:size="field.size"
						:fill="field.fill"
						:icon="field.icon"
						:expand="field.expand"
						:color="field.color"
						@clicked="buttonClicked(field.id)">
					</spot-button>
				</div>
			</div>
			<div id="debugArea" style="color:red;" v-if="settings.debug">
				<div>Test Area</div>
				<spot-button
					fill="outline"
					size="large"
					color="primary"
					:enabled="true"
					text="Simulate Scan"
					@clicked="onReadedBarcode('87196429','barcode')">
				</spot-button>
				<div v-for="field in fields" :key="field.id">
					{{ field.name }} = {{ field.value }}
				</div>
			</div>
		</ion-content>

 </ion-page>
</template>

<style scoped>
	ion-textarea {
		font-size: 12px;
		margin-top: 5px;
		margin-bottom: 0px;
		--padding-top: 0px;
		--padding-bottom: 0px;
		--inner-padding-top: 0px;
		--inner-padding-bottom: 0px;
		--min-height: 0px
	}
	*:deep(ion-checkbox) {
		margin-top: 0px;
		margin-bottom: 0px;
	}
</style>

<script>
import { IonContent, IonLabel, IonPage, IonProgressBar, IonTextarea } from '@ionic/vue';
import { defineComponent } from 'vue';
import SpotButton from '../components/SpotButton.vue';
import SpotCheckbox from '../components/SpotCheckbox.vue';
import SpotSelect from '../components/SpotSelect.vue';
import SpotInput from '../components/SpotInput.vue';
import SpotHeader from "../components/SpotHeader.vue";
import WebSocketReader from '../components/WebSocketReader.vue';
import { checkUserSession, settings, showMsgError, showMsgInfo, showMsgWarning, writeLog } from '../plugins/common.js';
import { executePrinterAction, getPrinter, jsonSearchItems, searchAdditionalBarcode, searchItem, searchPrinter, tablesData } from '../plugins/customDatabase.js';

export default defineComponent({
		name: "PrintPriceLabel",
		props: {
			pageTitle: { type: String, default: 'Stampa Cartellino' },
			printerName: {	type: String, default: 'Store Printer' },
			isPrintingText: { type: String, default: 'Invio dati alla stampante... Attendere'},
			unselected: { type: String, default: 'Nessuno' },
			selectedText: { type: String, default: 'Selezionato' },
			deselectText: { type: String, default: 'annulla' },
			selectText: { type: String, default: 'seleziona' },
			messageSearchItemTitle: { type: String, default: 'Ricerca Articolo' },
			messageSearchItemNotFound: { type: String, default: 'Articolo non trovato!' + '<br>' + 'Codice letto: ' },
			messageTitleCheckTAG: { type: String, default: 'Controllo TAG' },
			warnMultipleTAG: { type: String, default: 'Letto più di un TAG. Avvicinarsi solo al TAG da leggere e riprovare' },
			warnInavlidTAG: { type: String, default: 'TAG letto solo in parte. Riprovare a leggere' },
			messageTitleReader: { type: String, default: 'Lettura Barcode/TAG' },
			errorReadingReader: { type: String, default: 'Errore nella lettura del barcode/tag' },
			messageTitlePrint: { type: String, default: "Stampa Etichetta" },
			//successPrintMessage: { type: String, default: "Stampa etichetta avvenuta correttamente. Etichetta: " },
			successPrintMessage: { type: String, default: "Stampa etichetta avvenuta correttamente. Etichette stampate: " },
			errorPrintMessage: { type: String, default: "Errore durante la stampa dell'etichetta" },
			warningPrinterNotFound:	{ type: String, default: "Stampante non trovata" },
			warningPrinterOffline: { type: String, default: "Stampante non è raggiungibile. L'etichetta non può essere stampata" },
		},
		components: {
			IonPage,
			IonContent,
			IonProgressBar,
			IonLabel,
			IonTextarea,
			SpotHeader,
			SpotInput,
			SpotCheckbox,
			SpotSelect,
			SpotButton,
			WebSocketReader,
		},
		data: () => ({
			isActive: null,
			enableSearchFields: null,
			field: {
				code: 0,
				description: 1,
				externalCode: 2,
				barcode: 3,
				retailPrice: 4,
				quantity: 5,
				print: 6,
			},
			fields: [
				{ id: 0, name: 'code', text: 'Articolo', enabled: false, allignLabel: true, placeholder: 'Visualizza Codice Articolo', inputType: 'text', defaultValue: null, value: null, required: true, furtherInfo: null, validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
				{ id: 1, name: 'description', text: 'Descrizione', enabled: false, allignLabel: false, placeholder: 'Visualizza Descrizione', inputType: 'area', defaultValue: null, value: null, required: true, furtherInfo: null, validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
				{ id: 2, name: 'externalCode', text: 'ID', enabled: false, allignLabel: true, placeholder: 'Visualizza ID', inputType: 'text', defaultValue: null, value: null, required: true, furtherInfo: null, validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
				{ id: 3, name: 'barcode', text: 'Barcode', enabled: false, allignLabel: true, placeholder: 'Leggi Barcode', inputType: 'text', defaultValue: null, value: null, required: true, furtherInfo: null, validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
				{ id: 4, name: 'retailPrice', text: 'Prezzo', enabled: false, allignLabel: true, placeholder: 'Visualizza Prezzo', inputType: 'number', defaultValue: null, value: null, required: true, furtherInfo: ' €', validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
				{ id: 5, name: 'quantity', text: 'Nr. Etichette', enabled: true, allignLabel: true, placeholder: 'Inserisci Nr. Etichette', inputType: 'number',  defaultValue: null, value: null, required: true, furtherInfo: null, validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
				{ id: 6, name: 'print', text: 'Stampa', enabled: null, inputType: 'button', size: 'default', fill: 'solid', expand: 'block', icon: 'print', color: 'primary' },
			],
			searchField: { id: 0, name: 'search', text: 'Cerca', enabled: true, allignLabel: true, placeholder: 'Cerca Articolo', inputType: 'select', defaultValue: null, value: null, required: false, furtherInfo: null, validationState: null, refField: 'description', canAddItem: false, canRefresh: false, canUnlock: false },
			isPrinting: false,
			printerId: null,
			lastBarcode: null,
			lastTag: null,
			settings,
			checkUserSession,
			showMsgError,
			showMsgInfo,
			showMsgWarning,
			writeLog,
			getPrinter,
			jsonSearchItems,
			searchAdditionalBarcode,
			searchItem,
			searchPrinter,
			executePrinterAction,
			tablesData,
		}),
		async ionViewWillEnter() {
			this.getUrlParamsAndQuery();
			this.setDefault();
			await this.getAllTablesData();
			this.isActive = true;
		},
		ionViewWillLeave() {
			this.isPrinting = false;
			this.isActive=false;
		},
		computed: {
			isEmptyRequiredFields() {
				let ret = false;
				this.fields.forEach(element => {if (element.required && !element.value && element.id > 0) ret=true});
				return ret;
			},
			canPrint() {
				return (this.settings.printerManagement && (this.printerId != null))
			},
		},
		methods: {
			// Settings & StartUp
			getUrlParamsAndQuery() {
				this.enableSearchFields = (/true/i).test(this.$route.query.search);
			},
			setDefault() {
				this.fields.forEach(element => element.value = element.defaultValue);
				this.isPrinting = false;
				this.lastBarcode = null;
				this.lastTag = null;
			},
			getPlaceHolder(element) {
				return ((this.settings.showFieldsPlaceholder) ? (element.required ? element.placeholder : this.unselected ) : ' ')
			},
			getOptions(elementId) {
				let myOption = null;
				switch (elementId) {
					default:
						//Do Nothing
						break
				}
				return myOption;
			},
			buttonClicked(elementId) {
				let myOption = null;
				switch (elementId) {
					case this.field.print:
						this.printLabel();
						break;
					default:
						//Do Nothing
						break
				}
				return myOption;
			},
			// Database
			async getAllTablesData() {
				if (this.settings.printerManagement == true) {
					this.tablesData.printers = [];
					this.tablesData.currentPrinter = null;
					await this.searchPrinter(null,this.printerName);
					if (!this.tablesData.currentPrinter) {
						this.printerId = null;
						this.showMsgWarning(this.messageTitlePrint, this.warningPrinterNotFound)
						this.$router.push("/home")
					}
					else {
						this.printerId = this.tablesData.currentPrinter.id;
						if (!this.tablesData.currentPrinter.is_online) {
							this.showMsgWarning(this.messageTitlePrint, this.warningPrinterOffline)
							this.$router.push("/home")
						}
					}
				}
				if (this.enableSearchFields) {
					await this.searchPrintableItems();
				}
			},
			async searchPrintableItems() {
				this.tablesData.items = [];
				let mySearch = {
					"q": {
						"retail_price_not_null": true,
						"quantity_gt": 0,
						"locked_quantity_gt": 0,
						"barcode_not_null": true,
					},
				};
				await this.jsonSearchItems(mySearch);
			},
			// Actions
			async onReadedBarcode(barcode, type, gs1Data = null) {
				this.lastBarcode = barcode;
				this.writeLog(barcode, type, gs1Data);
				await this.committedBarcode();
			},
			async onReadedTag(tag,type) {
				this.lastTag = tag;
				this.writeLog(tag, type);
				await this.committedTag();
			},
			onReaderError(data,error) {
				this.showMsgError(data, error);
				this.showMsgWarning(this.messageTitleReader, this.errorReadingReader);
			},
			changedTextField(fieldId, value) {
				this.fields[fieldId].value = value;
				(!value || value.length == 0)? this.fields[fieldId].validationState = false : this.fields[fieldId].validationState = true
			},
			changedCheckboxField(fieldId, value) {
				this.fields[fieldId].value = value;
				(!value || value.length == 0)? this.fields[fieldId].validationState = false : this.fields[fieldId].validationState = true
			},
			assignedSelectField(fieldId, value) {
				this.fields[fieldId].value = value;
				(!value)? this.fields[fieldId].validationState = false : this.fields[fieldId].validationState = true
			},
			resetSelectField(fieldId) {
				this.fields[fieldId].value = null;
				this.fields[fieldId].validationState = false
			},
			selectedSearchItem(value) {
				this.searchField.value = value;
				this.onReadedBarcode(value.barcode, 'search');
			},
			updateFields(row) {
				Object.getOwnPropertyNames(row).forEach(rowField => {
					this.fields.forEach(pageElement => {
						if (rowField == pageElement.name) {
							pageElement.value = row[rowField];
						}
					});
				});
			},
			changedBarcode(value) {
				this.lastBarcode = value;
			},
			async searchBarcodeInTables() {
				let ret = null;
				this.tablesData.currentItem = null;
				this.tablesData.currentAdditionalBarcode = null;
				await this.searchItem(null, this.lastBarcode);
				if (!this.tablesData.currentItem) {
					await this.searchAdditionalBarcode(this.lastBarcode);
					if (!this.tablesData.currentAdditionalBarcode) {
						this.showMsgWarning(this.messageSearchItemTitle, this.messageSearchItemNotFound + this.lastBarcode);
					}
					else {
						ret = this.tablesData.currentAdditionalBarcode.item;
					}
				}
				else {
					ret = this.tablesData.currentItem;
				}
				return ret;
			},
			async committedBarcode() {
				let foundElement = null;
				foundElement = await this.searchBarcodeInTables();
				if (foundElement != null) {
					this.fields[this.field.code].value = foundElement.code
					this.fields[this.field.description].value = foundElement.description
					this.fields[this.field.externalCode].value = foundElement.external_code
					this.fields[this.field.barcode].value = foundElement.barcode
					this.fields[this.field.retailPrice].value = foundElement.retail_price
					this.fields[this.field.quantity].value = this.fields[this.field.quantity].defaultValue
				}
				else {
					this.setDefault();
				}
			},
			changedTag(value) {
				this.lastTag = value;
			},
			async committedTag() {
				let tagElements = this.lastTag.split('|');
				let foundElement = null;

				switch (tagElements.length) {
					case 0:
						this.lastTag = null;
						this.showMsgWarning(this.messageTitleCheckTAG,this.warnInavlidTAG);
						break;
					case 1:
						this.tablesData.items.some(item => {
							if (item.code == this.lastTag) {
								foundElement = item;
								return true;
							}
						});
						if (!foundElement) {
							this.showMsgWarning(this.messageSearchItemTitle, this.messageSearchItemNotFound + this.lastTag);
							this.setDefault();
						}
						else {
							this.fields[this.field.code].value = foundElement.code
							this.fields[this.field.description].value = foundElement.description
							this.fields[this.field.externalCode].value = foundElement.external_code
							this.fields[this.field.barcode].value = foundElement.barcode
							this.fields[this.field.retailPrice].value = foundElement.retail_price
							this.fields[this.field.quantity].value = this.fields[this.field.quantity].defaultValue
						}
						break;
					default:
						this.lastTag = null;
						this.showMsgWarning(this.messageTitleCheckTAG,this.warnMultipleTAG);
						break;
				}
			},
			preparePrinterData() { //
				`?x=${encodeURIComponent('test?')}`
				/*let retString = '?do=print_single_barcode&current_date=23%2F07%2F2024&customer_external_code=12345&customer_name=TORTONA%20TURKISH%20KEBAP%202%20DI%20AKBIVIK%20SAKIR%20E%20DI%20GABRIELE%20GIANLUCA%20CIAO&customer_address=CENTRO%20COMMERCIALE%20%20%22NUOVO%20BORGO%22%20CORSO%20CASALE%20N.319&customer_postal_code=40139&customer_locality=FRAZ.%20VALLE%20SAN%20BARTOLOMEO%20-%20ALESSANDRIA&customer_province=AL&package_incremental=1&project_packages_number=2&item_0_quantity=999&item_0_description=GUANTO%20BANCO%20NITRILE%20NERO%20GRIP%207,2%20GR%20PZ.50%20REINDOSSABILE%20NON%20USARE%20CERCARE%20CODICI%20MISURA&item_1_quantity=3&item_1_description=FAIRY%20LAVASTOVIGLIE%20ALL%20IN%20ONE%20PLATINUM%2075%20CAPS%20NEW%20FORMULA&item_2_quantity=10&item_2_description=CANDEGGINA%20LT.1&item_3_quantity=99&item_3_description=GUANTO%20BANCO%20NITRILE%20NERO%20GRIP%207,2%20GR%20PZ.50%20REINDOSSABILE%20NON%20USARE%20CERCARE%20CODICI%20MISURA&item_4_quantity=999&item_4_description=SACCHETTI%20BIANCHI%205%20cm.%2019x40&item_5_quantity=3&item_5_description=BIS%20POSATE%20STYLE%2033X33%20P%2F8%20BYO'%20PZ.500&item_6_quantity=10&item_6_description=ROTOLO%20TOVAGLIA%20TNT%20H.160cm.x%2010mt.PANNA&item_7_quantity=99&item_7_description=CARTA%20ACC.CARTENE%2033x44%20ST.FORNO&item_8_quantity=10&item_8_description=FAIRY%20LAVASTOVIGLIE%20ALL%20IN%20ONE%20PLATINUM%2075%20CAPS%20NEW%20FORMULA&item_9_quantity=99&item_9_description=GUANTO%20BANCO%20NITRILE%20NERO%20GRIP%207,2%20GR%20PZ.50%20REINDOSSABILE%20NON%20USARE%20CERCARE%20CODICI%20MISURA';*/

				let retString = `?do=print_single_barcode`;
				retString += `&item_code=${encodeURIComponent(this.fields[this.field.code].value)}`;
				retString += `&item_description=${encodeURIComponent(this.fields[this.field.description].value)}`;
				retString += `&item_external_code=${encodeURIComponent(this.fields[this.field.externalCode].value)}`;
				retString += `&item_barcode=${encodeURIComponent(this.fields[this.field.barcode].value)}`;
				retString += `&item_retail_price=${encodeURIComponent(this.fields[this.field.retailPrice].value)}`;
				retString += `&label_quantity=${encodeURIComponent(this.fields[this.field.quantity].value)}`;

				this.writeLog(retString);
				return retString;
			},
			async printLabel() {
				let ret = false;
				this.isPrinting = true;
				await this.getPrinter(this.printerId)
				if (this.tablesData.currentPrinter.is_online == true) {
					ret = true;
					// print labels
					await this.executePrinterAction(`printers/` + this.printerId + this.preparePrinterData())
					.then(() => { /*ret = true;*/ })
					.catch(error => {
						this.checkUserSession(error, "warning");
						this.showMsgError(this.messageTitlePrint, this.errorPrintMessage);
						ret = false;
					})
					if (ret == true) {
						this.showMsgInfo(this.messageTitlePrint, this.successPrintMessage + "&nbsp" + this.fields[this.field.quantity].value);
					}
				}
				else {
					this.showMsgWarning(this.messageTitlePrint,this.warningPrinterOffline);
				}
				this.isPrinting = false;
				return ret;
			},
		}
	});
</script>
